import { siteText } from '../siteText'
import { useState } from 'react'
import { UserRound } from 'lucide-react'

export function ProfileAvatar({ name, photo, className }: { name: string; photo: string | null; className: string }) {
  const [failedPhoto, setFailedPhoto] = useState<string | null>(null)
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase()
  return <span className={className} aria-hidden="true">
    {siteText(photo && photo !== failedPhoto ? <img src={photo} alt="" onError={() => setFailedPhoto(photo)} /> : initials || <UserRound size={17} />)}
  </span>
}
